'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const Translator = require('./../../../core/translator');

const DndZone = require('./dndZone');
const ResizeColumn = require('./resizeColumn');
const ContentManager = require('./../component/ContentManager');

const applyToElement = function($elements) {
    if ($elements.length === 0) {
        return;
    }

    const callback = function($element) {
            let $content = $element;
            let content;
            let rteConfig;

            if (!$element.attr('data-bb-identifier')) {
                $content = $element.parents('.bb-content:first');
            }

            content = ContentManager.getContentByNode($content);

            if (_.isEmpty(jQuery.trim($element.text())) && content) {
                rteConfig = content.getRteConfig();

                $element.attr('data-cloud-placeholder', Translator.translate(rteConfig.placeholder))
                        .addClass('cloud-text-placeholder');
            }
        };

    if ($elements.length > 1) {
        $elements.each(function() {
            callback(jQuery(this));
        });
    } else {
        callback($elements);
    }
};

const unApplyToElement = function($element) {
    $element.removeClass('cloud-text-placeholder');
};

module.exports.globalApply = function() {
    applyToElement(jQuery('[data-cloud-rte]'));

    DndZone.apply();
    ResizeColumn.apply();
};

module.exports.unApplyToElement = unApplyToElement;

module.exports.apply = function(content) {
    let $contentToEdit = content.$.find('[data-cloud-rte]');

    if (!$contentToEdit.length) {
        $contentToEdit = content.$;
    }

    if (_.isEmpty(jQuery.trim($contentToEdit.text()))) {
        $contentToEdit.html('');

        applyToElement($contentToEdit);
    } else {
        unApplyToElement($contentToEdit);
    }

    DndZone.apply();
    ResizeColumn.apply();
};
